module.exports = __webpack_public_path__ + "assets/4ae144284c7d2c7fa845cc7dd0bfc3b1.mp3";